import React from 'react';

import CompanyForm from 'components/Managers/Policy/Plans/Widgets/Company';

export default function CompanyInformation() {
  return (
    <>
      <section className="border-bottom border-light">
        <h1 className="mb-3">Company information</h1>

        <p>Manage your programs and assign your members.</p>
      </section>

      <CompanyForm />
    </>
  );
}
